import { PublicQueueInfo } from '@/services/catalogApi.service';
import { ConfiguracaoSolucao } from '@/lib/fakeApi';

interface Props {
  queue: PublicQueueInfo;
  config: ConfiguracaoSolucao;
  onJoin: (queueId: string) => void;
}

export default function HighlightQueueCard({ queue, config, onJoin }: Props) {
  const statusLabel = queue.status === 'active' ? 'Aberta' : 'Pausada';
  const statusClass =
    queue.status === 'active' ? 'bg-brand-green/10 text-status-ok' : 'bg-brand-attention/10 text-status-attention';
  const textColor = config.corTexto;

  return (
    <div
      className="rounded-2xl border border-border bg-scrim/35 backdrop-blur-md shadow-2xl p-6"
      style={{ color: textColor }}
    >
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-2xl font-bold">{queue.name}</h2>
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass}`}>
          {statusLabel}
        </span>
      </div>

      {queue.description && (
        <p className="text-sm opacity-80 mb-4">{queue.description}</p>
      )}

      {!config.modoAgendamento && (
        <div className="flex gap-6 mb-6 text-sm opacity-90">
          <span>{queue.currentSize} na fila</span>
          <span>~{queue.estimatedWait} min de espera</span>
        </div>
      )}

      <button
        onClick={() => onJoin(queue.queueId)}
        className="w-full py-3 rounded-full font-semibold text-lg shadow-lg hover:opacity-90 transition-opacity"
        style={{ background: config.corPrincipal, color: config.corTexto }}
      >
        {config.modoAgendamento ? 'Agendar' : 'Entrar na Fila'}
      </button>
    </div>
  );
}
